var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    fill: "#002E6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 10.3335H24.5V12.0002H16.1667V10.3335ZM16.1667 13.6668H21.1667V15.3335H16.1667V13.6668ZM16.1667 18.6668H24.5V20.3335H16.1667V18.6668ZM16.1667 22.0002H21.1667V23.6668H16.1667V22.0002ZM9.5 10.3335H14.5V15.3335H9.5V10.3335ZM11.1667 12.0002V13.6668H12.8333V12.0002H11.1667ZM9.5 18.6668H14.5V23.6668H9.5V18.6668ZM11.1667 20.3335V22.0002H12.8333V20.3335H11.1667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowModal);
export default __webpack_public_path__ + "static/media/show_modal.fd9df84850ec92374efb17f7893a082d.svg";
export { ForwardRef as ReactComponent };